// extracted by mini-css-extract-plugin
module.exports = {"Link":"CastScreen__Link__jiA3S","LinkSpot":"CastScreen__LinkSpot__3kzRw","MainImg":"CastScreen__MainImg__3MrxK","LoginButton":"CastScreen__LoginButton__3ByRL"};